module.exports = __webpack_public_path__ + "static/media/aegon.ec9f6e3c.svg";